'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputGroup = function InputGroup(_ref) {
    var children = _ref.children,
        stacked = _ref.stacked,
        label = _ref.label,
        asButtons = _ref.asButtons;
    return _react2.default.createElement("div", { className: "luna-form__field" }, _react2.default.createElement("label", { className: "luna-label luna-label--fluid" }, label), stacked || asButtons ? _react2.default.createElement("div", { className: (stacked ? 'luna-form__stacked' : '') + ' ' + (asButtons ? 'luna-radioButtons' : '') }, children) : children);
};
InputGroup.propTypes = {
    stacked: _propTypes2.default.bool,
    label: _propTypes2.default.node,
    asButtons: _propTypes2.default.bool
};
exports.default = InputGroup;
//# sourceMappingURL=InputGroup.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/InputGroup/InputGroup.js